import React from 'react';
import { TableElement } from "./Table";
export var Table = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(TableElement, Object.assign({
    ref: ref
  }, props));
});
/**
* **Table** ![Status: Production](https://img.shields.io/badge/PRODUCTION-%2357B560|height=14)
*
* [GitHub](https://ghe.spotify.net/encore/web/tree/master/src/core/components/Table) | [Storybook](https://encore-web.spotify.net/?path=/docs/components-table--default) | [Encore](https://encore.spotify.net/web/components/table?format=figma-figma) | [Figma](https://www.figma.com/file/bnQXqGkLeiTlbk8JXGDcsX/Encore-Web---Light-Theme-Toolkit?node-id=525:1445) |
*
* null
*
* @example
* () => (
*  <Table>
*    <colgroup>
*      <col />
*      <col width="20%" />
*      <col width="20%" />
*      <col width="20%" />
*      <col width="20%" />
*      <col width="20%" />
*    </colgroup>
*    <thead>
*      <TableRow>
*        <TableHeaderCell align="center">#</TableHeaderCell>
*        <TableHeaderCell>Header</TableHeaderCell>
*        <TableHeaderCell>Header</TableHeaderCell>
*        <TableHeaderCell>Header</TableHeaderCell>
*        <TableHeaderCell>Header</TableHeaderCell>
*        <TableHeaderCell align="right" active>
*          <TableSortIcon />
*          Header
*        </TableHeaderCell>
*      </TableRow>
*    </thead>
*    <tbody>
*      <TableRow>
*        <TableCell numerical align="center">
*          1
*        </TableCell>
*        <TableCell highlight>Cell</TableCell>
*        <TableCell>Cell</TableCell>
*        <TableCell>Cell</TableCell>
*        <TableCell>Cell</TableCell>
*        <TableCell numerical align="right">
*          1000
*        </TableCell>
*      </TableRow>
*      <TableRow>
*        <TableCell numerical align="center">
*          2
*        </TableCell>
*        <TableCell highlight>Cell</TableCell>
*        <TableCell>Cell</TableCell>
*        <TableCell>Cell</TableCell>
*        <TableCell>Cell</TableCell>
*        <TableCell numerical align="right">
*          800
*        </TableCell>
*      </TableRow>
*      <TableRow>
*        <TableCell numerical align="center">
*          3
*        </TableCell>
*        <TableCell highlight>Cell</TableCell>
*        <TableCell>Cell</TableCell>
*        <TableCell>Cell</TableCell>
*        <TableCell>Cell</TableCell>
*        <TableCell numerical align="right">
*          600
*        </TableCell>
*      </TableRow>
*      <TableRow>
*        <TableCell numerical align="center">
*          4
*        </TableCell>
*        <TableCell highlight>Cell</TableCell>
*        <TableCell>Cell</TableCell>
*        <TableCell>Cell</TableCell>
*        <TableCell>Cell</TableCell>
*        <TableCell numerical align="right">
*          400
*        </TableCell>
*      </TableRow>
*    </tbody>
*  </Table>
*);
*
*/

export default Table;